export const allApplicationRequiredFields = [
    //Applicant Information
    "firstNamedInsuredCompany",
    "firstNamedInsuredContact",
    "firstNamedInsuredAddress",
    "firstNamedInsuredCity",
    "firstNamedInsuredState",
    "firstNamedInsuredZipCode",

    //Insured Total amount revenues
    "contractingRevenuesPriorCalendarYear",
    "contractingRevenuesCurrentCalendarYear"
]

export const otherQuestions = [
    {
        field: "operationsPerformedOutsideOfUs"
    },
    {
        field: "hasPurchasedProfessionalLiabilityOrContractorPollutionLiabilityInsurance"
    },
    {
        field: "hasClaimsOrLegalActionsAgainstInsureds",
        explanation: "hasClaimsOrLegalActionsAgainstInsuredsExplanation"
    },
    {
        field: "hasPollutionIncidents",
        explanation: "hasPollutionIncidentsExplanation"
    },
    {
        field: "hasDamageOrInjuryToProperty",
        explanation: "hasDamageOrInjuryToPropertyExplanation"
    },
    {
        field: "hasCircumstancesToGiveRiseToClaim",
        explanation: "hasCircumstancesToGiveRiseToClaimExplanation"
    }
]
